/**
 * AST 기반 자동 생성된 검증 함수
 * 이 파일은 scripts/generate-validators.ts에 의해 자동 생성됩니다.
 * 수동으로 수정하지 마세요.
 * 
 * 생성 시간: 2026-09-18T08:13:01.405Z
 * 소스 파일: src/data/dto/super-admin/action-log-response-dto
 */

import type { ActionLogResponseDto } from "@/data/dto/super-admin/action-log-response-dto";

/**
 * ActionLogResponseDto 타입 가드 함수
 * AST 분석을 통해 자동 생성된 최적화된 검증 함수
 */
export function isActionLogResponseDto(input: unknown): input is ActionLogResponseDto {
  if (typeof input !== "object" || input === null || Array.isArray(input)) {
    return false;
  }
  
  const obj = input as Record<string, unknown>;
  
  return (
    typeof obj.totalCount === "number" && !isNaN(obj.totalCount) &&
    typeof obj.totalPage === "number" && !isNaN(obj.totalPage) &&
    Array.isArray(obj.list) && obj.list.every((item) => typeof item === "object" && item !== null && !Array.isArray(item) &&
typeof (item as any).code === "string" &&
typeof (item as any).eventType === "string" &&
typeof (item as any).eventAction === "string" &&
typeof (item as any).component === "string" &&
  ((item as any).parameter === undefined || ((item as any).parameter == null || typeof (item as any).parameter === "string")) &&
typeof (item as any).pageScene === "string" &&
typeof (item as any).occurredAt === "string" &&
typeof (item as any).occurredAtOffset === "string")
  );
}

/**
 * ActionLogResponseDto 상세 검증 결과 반환 함수
 * 검증 실패 시 상세한 에러 정보를 반환합니다.
 */
export interface IValidation<T> {
  success: boolean;
  data?: T;
  errors?: Array<{ path: string; expected: string; value: unknown }>;
}

export function validateActionLogResponseDto(input: unknown): IValidation<ActionLogResponseDto> {
  const errors: Array<{ path: string; expected: string; value: unknown }> = [];
  
  if (typeof input !== "object" || input === null || Array.isArray(input)) {
    errors.push({
      path: "",
      expected: "object",
      value: input,
    });
    return {
      success: false,
      errors,
    };
  }
  
  const obj = input as Record<string, unknown>;
  
    if (typeof obj !== "object" || obj === null || Array.isArray(obj)) {
      errors.push({ path: "", expected: "object", value: obj });
    } else {
      const objObj = obj as Record<string, unknown>;
      // totalCount (required)
      if (objObj.totalCount === undefined) {
        errors.push({ path: "totalCount", expected: "number", value: undefined });
      } else {
        if (!(typeof objObj.totalCount === "number" && !isNaN(objObj.totalCount))) {
          errors.push({ path: "totalCount", expected: "number", value: objObj.totalCount });
        }
      }
      // totalPage (required)
      if (objObj.totalPage === undefined) {
        errors.push({ path: "totalPage", expected: "number", value: undefined });
      } else {
        if (!(typeof objObj.totalPage === "number" && !isNaN(objObj.totalPage))) {
          errors.push({ path: "totalPage", expected: "number", value: objObj.totalPage });
        }
      }
      // list (required)
      if (objObj.list === undefined) {
        errors.push({ path: "list", expected: "array", value: undefined });
      } else {
        if (!Array.isArray(objObj.list)) {
          errors.push({ path: "list", expected: "array", value: objObj.list });
        } else {
          objObj.list.forEach((item, idx) => {
              if (typeof item !== "object" || item === null || Array.isArray(item)) {
          errors.push({ path: "list[idx]", expected: "object", value: item });
        } else {
          const itemObj = item as Record<string, unknown>;
          // code (required)
          if (itemObj.code === undefined) {
            errors.push({ path: "list[idx].code", expected: "string", value: undefined });
          } else {
            if (typeof itemObj.code !== "string") {
              errors.push({ path: "list[idx].code", expected: "string", value: itemObj.code });
            }
          }
          // eventType (required)
          if (itemObj.eventType === undefined) {
            errors.push({ path: "list[idx].eventType", expected: "string", value: undefined });
          } else {
            if (typeof itemObj.eventType !== "string") {
              errors.push({ path: "list[idx].eventType", expected: "string", value: itemObj.eventType });
            }
          }
          // eventAction (required)
          if (itemObj.eventAction === undefined) {
            errors.push({ path: "list[idx].eventAction", expected: "string", value: undefined });
          } else {
            if (typeof itemObj.eventAction !== "string") {
              errors.push({ path: "list[idx].eventAction", expected: "string", value: itemObj.eventAction });
            }
          }
          // component (required)
          if (itemObj.component === undefined) {
            errors.push({ path: "list[idx].component", expected: "string", value: undefined });
          } else {
            if (typeof itemObj.component !== "string") {
              errors.push({ path: "list[idx].component", expected: "string", value: itemObj.component });
            }
          }
          // parameter (optional)
          if (itemObj.parameter !== undefined) {
            if (!(itemObj.parameter == null || typeof itemObj.parameter === "string")) {
              errors.push({ path: "list[idx].parameter", expected: "string | null", value: itemObj.parameter });
            }
          }
          // pageScene (required)
          if (itemObj.pageScene === undefined) {
            errors.push({ path: "list[idx].pageScene", expected: "string", value: undefined });
          } else {
            if (typeof itemObj.pageScene !== "string") {
              errors.push({ path: "list[idx].pageScene", expected: "string", value: itemObj.pageScene });
            }
          }
          // occurredAt (required)
          if (itemObj.occurredAt === undefined) {
            errors.push({ path: "list[idx].occurredAt", expected: "string", value: undefined });
          } else {
            if (typeof itemObj.occurredAt !== "string") {
              errors.push({ path: "list[idx].occurredAt", expected: "string", value: itemObj.occurredAt });
            }
          }
          // occurredAtOffset (required)
          if (itemObj.occurredAtOffset === undefined) {
            errors.push({ path: "list[idx].occurredAtOffset", expected: "string", value: undefined });
          } else {
            if (typeof itemObj.occurredAtOffset !== "string") {
              errors.push({ path: "list[idx].occurredAtOffset", expected: "string", value: itemObj.occurredAtOffset });
            }
          }
        }
          });
        }
      }
    }
  
  if (errors.length === 0 && isActionLogResponseDto(input)) {
    return {
      success: true,
      data: input,
    };
  }
  
  return {
    success: false,
    errors: errors.length > 0 ? errors : [
      {
        path: "",
        expected: "ActionLogResponseDto",
        value: input,
      },
    ],
  };
}

/**
 * ActionLogResponseDto 검증 후 에러 throw 함수
 * 검증 실패 시 상세한 에러 정보를 포함하여 에러를 throw합니다.
 */
export function assertActionLogResponseDto(input: unknown): ActionLogResponseDto {
  const validation = validateActionLogResponseDto(input);
  if (!validation.success) {
    const errorDetails = validation.errors?.map(err => 
      `  - ${err.path}: 예상 타입 ${err.expected}, 실제 값: ${JSON.stringify(err.value)}`
    ).join("\n") || "알 수 없는 오류";
    throw new Error(`[assertActionLogResponseDto] :: 검증 실패: ActionLogResponseDto 타입과 일치하지 않습니다\n\n오류 상세:\n${errorDetails}`);
  }
  return validation.data!;
}
